var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Transition",
    { attrs: { name: "financeApplicationOverlayTransition" } },
    [
      _vm.isOpen
        ? _c("div", { staticClass: "financeApplicationOverlay" }, [
            _c(
              "button",
              {
                staticClass: "financeApplicationOverlay__close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "financeApplicationOverlay__close__lines",
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "financeApplicationOverlay__body" },
              [_vm._t("default")],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }